import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useLanguage } from "../i18n/LanguageContext";
import { Chapter, Reveal } from "./shared";

const ABOUT_IMG = "/images/real-car-door.webp";

const About = () => {
  const { t } = useLanguage();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const imgY = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section data-testid="about-section" ref={ref} className="section-alt">
      <div className="relative mx-auto max-w-6xl px-5 sm:px-8 py-20 sm:py-28">
        <Chapter title={t.about.title} />

        <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-20">
          {/* Marco recortado con parallax interno */}
          <Reveal>
            <div className="card-elevated relative overflow-hidden rounded-3xl aspect-[4/5] max-h-[560px] w-full">
              <motion.img
                src={ABOUT_IMG}
                alt="UNLockSmiths branded car door with 24/7 emergency locksmith details"
                loading="lazy"
                style={{ y: imgY }}
                className="absolute inset-0 h-[116%] w-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0B1015]/90 via-[#0B1015]/20 to-transparent" />
              {/* Comentario de impacto sobre la foto: apertura de coches */}
              <div data-testid="about-photo-overlay" className="absolute bottom-6 left-6 right-6">
                <span className="mb-3 block h-1 w-14 rounded-full bg-gradient-to-r from-yellow-300 via-amber-400 to-amber-600 shadow-[0_0_14px_rgba(234,179,8,0.5)]" />
                <p className="font-heading text-lg sm:text-xl font-bold leading-snug tracking-[-0.01em] text-slate-50 drop-shadow-lg">
                  {t.about.overlay}
                </p>
              </div>
            </div>
          </Reveal>

          <div data-testid="about-story-text">
            <Reveal delay={0.1}>
              <p className="text-base sm:text-lg leading-relaxed text-slate-300">{t.about.p1}</p>
            </Reveal>
            <Reveal delay={0.2}>
              <p className="mt-6 text-base sm:text-lg leading-relaxed text-slate-400">{t.about.p2}</p>
            </Reveal>

            <div className="mt-12 grid grid-cols-2 gap-5">
              {t.about.stats.map((s, i) => (
                <Reveal key={s.value} delay={0.25 + i * 0.1}>
                  <div className="card-elevated card-lift rounded-2xl p-6">
                    <div className="font-heading text-3xl sm:text-4xl font-extrabold tracking-[-0.03em] bg-gradient-to-br from-slate-50 to-slate-400 bg-clip-text text-transparent">
                      {s.value}
                    </div>
                    <div className="mt-2 text-xs sm:text-sm text-slate-500">{s.label}</div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
